import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { getList, addData } from "../../helpers/fackBackend_Helper";

function* getTransactionReportsResponse({ payload: { data } }) {
  try {
    const response = yield call(addData, "/api/V1/Reports/TransactionReport", data,);
    if (response?.statusCode == 1200) {
      yield put(actions.transactionReportsSuccess(response?.data));
    } else {
      yield put(actions.transactionReportsFailed(response.message));
    }
  } catch (error) {
    yield put(actions.transactionReportsFailed(error.message));
  }
}


function* getactivationBatchReportsResponse({ payload: { data } }) {
  try {
    const response = yield call(addData, "/api/V1/Reports/BatchReports", data,);
    if (response?.statusCode == 1200) {
      yield put(actions.activationBatchReportsSuccess(response?.data));
    } else {
      yield put(actions.activationBatchReportsFailed(response.message));
    }
  } catch (error) {
    yield put(actions.activationBatchReportsFailed(error));
  }
}

function* getrechargeBatchReportsResponse({ payload: { data } }) {
  try {
    const response = yield call(addData, "/api/V1/Reports/RechargeBatchReports", data,);
    if (response?.statusCode == 1200) {
      yield put(actions.rechargeBatchReportsSuccess(response?.data));
    } else {
      yield put(actions.rechargeBatchReportsFailed(response.message));
    }
  } catch (error) {
    yield put(actions.rechargeBatchReportsFailed(error));
  }
}

function* wifiBatchReportsResponse({ payload: { data } }) {
  try {
    const response = yield call(addData, "/api/V1/Reports/WifiBatchReports", data,);
    if (response?.statusCode == 1200) {
      yield put(actions.getWiFiBatchReportsSuccess(response?.data));
    } else {
      yield put(actions.getWiFiBatchReportsFailed(response.message));
    }
  } catch (error) {
    yield put(actions.getWiFiBatchReportsFailed(error));
  }
}


export default function* rootSaga() {
  yield all([
    takeEvery(actions.TRANSACTION_REPORTS, getTransactionReportsResponse),
    takeEvery(actions.ACTIVATION_BATCH_REPORTS, getactivationBatchReportsResponse),
    takeEvery(actions.RECHARGE_BATCH_REPORTS, getrechargeBatchReportsResponse),
     takeEvery(actions.WIFI_BATCH_REPORTS, wifiBatchReportsResponse)
  ]);
}
